import Head from 'next/head';
import Layout from '../../components/layouts/layout';
import ScheduleList from '../../components/schedule-list/schedule-list';
import YoutubeContainer from '../../components/youtube-container/youtube-container';
import { addApolloState, initializeApollo } from '../../lib/apolloClient';
import fetchRetreatsPage from '../../lib/queries/fetchRetreatsPage';
import useResponsive from '../../lib/useResponsive';
import styles from './trainings.module.scss';
import { orderBy } from 'lodash';

export default function TeacherTraining({ contents, retreats }) {
  const { isDesktop } = useResponsive();

  return (
    <Layout logoType="big" title={contents.title} background={contents.featured_image}>
      <Head>
        <title>Retreats Overview - The Sacred Fig</title>
        <meta name="description" content={contents.short_description} />
        <meta name="image" content={contents.featured_image} />
      </Head>
      {/* <Seo seo={tt.seo} /> */}

      <div className={styles.intro}>
        <p>{contents.short_description}</p>
      </div>

      <div className={styles.youtube}>
        <YoutubeContainer embedCode={contents.embed_code} fullWidth={true}></YoutubeContainer>
      </div>

      <div className={styles.schedule}>
        <ScheduleList title="Schedule" trainings={retreats} type="retreats"></ScheduleList>
      </div>
    </Layout>
  );
}

export async function getStaticProps() {
  const apolloClient = initializeApollo();

  const { data } = await apolloClient.query({
    query: fetchRetreatsPage,
  });

  return addApolloState(apolloClient, {
    props: { contents: data.retreatsPage, retreats: orderBy(data.retreats, ['start_date'], ['asc']) },
    revalidate: 1,
  });
}
